<script>
export default {
   inserted: function (el) {
        var headers = el.getElementsByTagName('li');
        var items = el.getElementsByClassName('item');

        var setOnclick = function(ctl, id) {
            ctl.onclick = function() {
                for(var i = 0; i < headers.length; i++) {
                    headers[i].classList.remove('active');
                }
                ctl.classList.add('active');
                var type = ctl.dataset.type;

                for(var ii = 0; ii < items.length; ii++) {
                    if (type == 'all' || items[ii].classList.contains(type)) {
                        items[ii].classList.add('active');
                    } else {
                        items[ii].classList.remove('active');
                    }
                }
                return false;
            }
        }
        for(var i = 0; i < headers.length; i++) {
            setOnclick(headers[i], i);
        }
   }
}
</script>